// ------------------------------------
// props 輸入需求 :
// props.content : object : { data: array }            ( 呈現內容 )
// ------------------------------------

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import ApiGo from '../../actions/ApiGo';
import dataHandler_alert from '../../actions/dataHandler_alert';
import { LogTime } from '../../actions/forFrontEnd_Log';
import { ADD_ALERTS_ARRAY, ADD_ALERTS_ARRAY_RESIDENT } from '../../stores/reducer_alerts';
import { ADD_BEDS_ARRAY } from '../../stores/reducer_beds';
import { DF } from '../dashboard/DashFunction';
import { HR, RR } from '../residents/historyRecord/HISVital/SVGRRHR';
import ConfigHandler from '../../actions/ConfigHandler';
import './_PopConfirm.scss';

const AlertCancel = (props) => {
    const resident = props.resident
    const content = props.content
    const dispatch = useDispatch()
    const store_res_array = useSelector(state => state.store_residents.orign_residents_array)
    const { t } = useTranslation()

    function handlePic(type, alert_type_id = "") {
        if (type === "rr") { return { img: <RR type={"icon_pic"} />, alert: '呼吸警訊' } }
        if (type === "hr") { return { img: <HR type={"icon_pic"} />, alert: '心跳警訊' } }
        if (type === "bedState") {
            return { img: <img className='upperPic bedState' src={dataHandler_alert('2', alert_type_id).img} alt="動態警訊" />, alert: t("GLOBAL.ALERT") }
        }
    }


    async function getAlert() {

        let [alert, vital, resident_arr, unResolved] = [{}, [], [], []]
        try {
            vital = await ApiGo.getAll_resident_vital_abnormal(new LogTime().getDate(), "ALL")
            unResolved = vital.filter(res =>
                res.resolved === null &&
                !(ConfigHandler.isFdaClass === 2 && res.type === 'rr')
            )
        }
        catch {
            unResolved = []
        }
        try {
            alert = await ApiGo.getAll_resident_bed_state_alerts(new LogTime().getDate(), "ALL")
            let _temp = alert.alerts.filter(res => res.resolved === null)
            unResolved = [..._temp, ...unResolved]
        }
        catch {
            unResolved = []
        }

        dispatch(ADD_ALERTS_ARRAY(unResolved))

        unResolved.forEach(res => {
            let resident = store_res_array.filter(store => store.id === res.resident_id)[0]
            if (resident === undefined) return
            if (resident_arr.indexOf(resident.id) === -1) { resident_arr.push(resident.id) }
        })

        dispatch(ADD_ALERTS_ARRAY_RESIDENT(resident_arr))
    }

    function resolveAlert() {
        const email = localStorage.getItem("currentAccount")
        const user = JSON.parse(localStorage.getItem(email))
        //  const bed = props.bed
        ApiGo.putUpdate_alerts_resolved(resident.id, user.id)
            .then(() => {
                speechSynthesis.cancel()  // ✅ 解除警訊時暫停音訊
                getAlert()
                ApiGo.getBed()
                    .then(bed => { dispatch(ADD_BEDS_ARRAY(bed.beds) || []) })
                    .catch(err => { console.log(err); })
                props.hide(resident)
            })
            .catch(err => { console.log(err); })
    }
    return (
        <div className="pos-f z-3 wid-full hig-full top-0 left-0 fx-ccc bg-back" onClick={() => { props.hide(resident) }}>
            <div className="popLayout alertCancel fx-d-c pad-30 l r" onClick={e => e.stopPropagation()}>
                <div className='w-100 fx-d-r font-ml innerFrame mt mar-30 b t'>
                    <div className="font-l fx-fsc w-40">
                        {t("GLOBAL.UNRESOLVEED") + t("GLOBAL.NOTIFICATION")}
                        <div className="notf_count fx-ccc br-10 mar-5 b">{content.length}</div>
                    </div>
                    <div className='w-60 fx-ccc'>
                        <div className="top-tag fx-d-r mar-r">
                            <div className="name fx-ccc">{t("GLOBAL.BED_NO")}</div>
                            <div className="body def"><div className="inner">{DF.abbreviate(resident.first_name, 3)}</div></div>
                        </div>
                        <div className="top-tag fx-d-r mar-r mar-10per l">
                            <div className="name fx-ccc">{(props.type === 'bed') ? t("GLOBAL.BED_NO") : t("GLOBAL.NAME")}</div>
                            <div className="body def"><div className="inner">{DF.abbreviate(resident.last_name, 3)}</div></div>
                        </div>
                    </div>
                </div>
                <div className='w-100 h-65 innerFrame mt ovf'>
                    {content !== "" ?
                        content.map((res, index) => {
                            if (res.type !== undefined) {
                                return <div className='w-100 fx-d-r innerRow' key={index}>
                                    <div className='w-20 fx-fsc'>{res.created_at.split("T")[1]}</div>
                                    <div className='w-10 cardDefaultCF fx-ccc'>
                                        {res.type === "rr" ? <RR type={"icon_pic"} /> : <HR type={"icon_pic"} />}
                                    </div>
                                    <div className='w-20 fx-fsc'>{res.abnormal}</div>
                                    <div className='w-50 fx-fsc'>{res.value}</div>
                                    <div></div>
                                </div>
                            } else {
                                if (res.abnormal_type === undefined) {
                                    return <div className='w-100 fx-d-r innerRow' key={index}>
                                        <div className='w-20 fx-fsc'>{res.timestamp.split(" ")[1]}</div>
                                        <div className='w-10 cardDefaultCF fx-ccc'>{handlePic("bedState", res.bedState).img}</div>
                                        <div className='w-20 fx-fsc'>{handlePic("bedState", res.bedState).alert}</div>
                                        <div className='w-50 fx-fsc'>{t(dataHandler_alert('2', res.bedState).msg)}</div>
                                        <div></div>
                                    </div>
                                }
                            }

                        })
                        : null}
                </div>
                <div className="wrap-sensor-btn w-100 innerFrame cfBtn">
                    <div className="h-100 r-s-container"></div>
                    <div className="h-100 l-s-container">
                        <div className="h-100 flied">
                            <div className="fx-ccc w-50 btn_type confirmBtn" onClick={resolveAlert}>{t('GLOBAL.REMOVE')}</div>
                            <div className="fx-ccc w-50 btn_type confirmBtn" onClick={() => { props.hide(resident) }}>{t('GLOBAL.CANCEL')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

}
export default AlertCancel;
